// @flow
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

type Props = {
  initializedStore: Object
};

const BrowserApp = ({ initializedStore }: Props) => (
  <BrowserRouter>
    <Provider store={initializedStore}>
      <App />
    </Provider>
  </BrowserRouter>
);

export default BrowserApp;
